import { render, staticRenderFns } from "./GeneralSettingContactEmail.vue?vue&type=template&id=c4e32c18&"
import script from "./GeneralSettingContactEmail.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports